import { InfoCircleOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { Modal, Button, ConfigProvider, Checkbox } from 'antd';
import colorTokens from '../../constants/design_system/colors';
import { SprintStatusLabel } from '../UI/SprintStatusLabel';
import CustomTooltip from '../UI/Tooltip/CustomTooltip';
import { useState } from 'react';

interface EndSprintModalProps {
  open: boolean;
  onOk: (moveUnfinishedTasksToPlanning: boolean) => void;
  onCancel: () => void;
  unfinishedTasksLength: number;
}

export const EndSprintModal = (props: EndSprintModalProps) => {
  const { open, onCancel, onOk, unfinishedTasksLength } = props;

  const [moveUnfinishedTasksToPlanning, setMoveUnfinishedTasksToPlanning] = useState(true);

  const handleOk = () => {
    onOk(moveUnfinishedTasksToPlanning);
  };

  return (
    <Modal
      okText="Complete Sprint"
      cancelText="Cancel"
      okType="primary"
      width={'580px'}
      open={open}
      title="Complete the Sprint"
      styles={{ header: { marginLeft: '16px' }, body: { marginLeft: '16px' } }}
      onCancel={onCancel}
      onOk={handleOk}
      centered
      footer={
        <div className="flex flex-row justify-between items-center">
          <div
            className={`flex flex-row items-center w-fit bg-neutral-200 p-1 rounded-md ${!moveUnfinishedTasksToPlanning ? 'invisible' : ''}`}
          >
            <CustomTooltip
              title={`${unfinishedTasksLength} task${unfinishedTasksLength > 1 ? 's' : ''} would be moved to Planning state`}
            >
              <InfoCircleOutlined className="text-neutral-800 mr-2" />
            </CustomTooltip>
            <strong>
              {unfinishedTasksLength} task{unfinishedTasksLength > 1 ? 's' : ''}
            </strong>
            <SprintStatusLabel className="ml-2" sprintStatus={'sprint'} component={'table'} />
            <ArrowRightOutlined className="mx-2" />
            <SprintStatusLabel sprintStatus={'planning'} component={'table'} />
          </div>
          <div>
            <Button className="py-[5px]" key="back" onClick={() => onCancel()}>
              Cancel
            </Button>
            <Button className="ml-3 py-[5px]" key="submit" type="primary" onClick={handleOk}>
              Complete Sprint
            </Button>
          </div>
        </div>
      }
    >
      <div className="mt-6">
        <ConfigProvider
          theme={{
            components: {
              Checkbox: {
                colorPrimary: colorTokens.blue[600],
                colorPrimaryHover: colorTokens.blue[700],
              },
            },
          }}
        >
          <Checkbox
            className="mr-2"
            checked={moveUnfinishedTasksToPlanning}
            onChange={() => setMoveUnfinishedTasksToPlanning(!moveUnfinishedTasksToPlanning)}
          ></Checkbox>
          Move tasks you haven’t started or finished yet to Planning state.
        </ConfigProvider>
      </div>
      <div className="h-8"></div>
    </Modal>
  );
};
